import React from 'react'
import Dialog from 'material-ui/Dialog'
import { useEffect, useState } from 'react'

export const ModalSettingMenuPremiumCreate = (props) => {
    const [isShow, setShow] = useState(false)

    useEffect(() => {
        setShow(props.isShow)
    }, [props.isShow])

    const closeDialog = () => setShow(true)

    const onCancel = async () => {
        closeDialog()
        await props.resetToggle()
        props.onClose()
    }
    const titleStyle = {
        margin: '0 69px 25px 70px',	
        fontFamily: 'HiraKakuPro-W6',
        fontSize: '18px',
        fontWeight: '700',
        fontStyle: 'normal',
        lineHeight: 1.17,
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#11ad9d',
      };
    const pStyle = {
        margin: '25px 0',	
        fontFamily: 'HiraKakuPro-W3',
        fontSize: '14px',
        fontWeight: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.43,
        letterSpacing: 'normal',
        color: '#212121',
    }
    const textStyle = {
        color: '#ec407a',
    }
  
    return (
        


        <div>
            <Dialog
                modal={false}
                open={isShow}
                bodyClassName="modal-missing__profile setting-popup-overflow"
                contentClassName="modal-menu-premium-paper setting-popup-template"

            >
                <div className="modal-missing__profile-content" id="content-appeal__message">
                    <h3 style={titleStyle}>提出完了</h3>
                    <p style={pStyle}>設定されたプレミアムメニューを提出いたしました。<br></br>
                         事務局にて審査が行われ、承認後プロフィールへ掲載されます。
                    </p>
                    <p style={pStyle}> そのためお時間をいただきます。<br></br>
                    しばらくお待ちください。</p>
                </div>
                <div className="modal-appeal__message-btn">
                    <input
                        type="button"
                        value="OK"
                        className="modal-appeal__message-btn-cancel"
                        onClick={onCancel}
                    />
                </div>
            </Dialog>
        </div>
    )
}
